@if (fabTogglerState === 'active') {
  <div id="fab-dismiss"
    (click)="onToggleFab()">
  </div>
}
<div class='fab-button-container'>
  @if (buttons.length > 0) {
    <div [@speedDialStagger]="buttons.length">
      @for (btn of buttons; track btn) {
        <div (click)="!btn.disabled && onClickFab(btn)" [class]="'fab-entry fab-entry-' + btn.action">
          <button mat-mini-fab color="secondary" [disabled]="btn.disabled">
            @if (btn.icon) {
              <i class="material-icons">{{btn.icon}}</i>
            }
            @if (btn.svgIcon) {
              <mat-icon [svgIcon]="btn.svgIcon"></mat-icon>
            }
          </button>
          <label class="fab-button-label">{{ btn.label }}</label>
        </div>
      }
    </div>
  }
  @if (fabButtons.length > 0) {
    <button mat-fab class="fab-toggler" color="primary" (click)="onToggleFab()">
      <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">{{ toggleIcon }}</i>
    </button>
  }
</div>
